import gsap from "gsap";
import { TextPlugin } from "gsap/TextPlugin";
import { useGSAP } from "@gsap/react";
import { heroVideo, smallHeroVideo } from "../utils";
import { useEffect, useState, useRef } from "react";

gsap.registerPlugin(TextPlugin);

const Hero = () => {
  const [videoSrc, setVideoSrc] = useState(
    window.innerWidth < 760 ? smallHeroVideo : heroVideo,
  );

  const containerRef = useRef(null);
  const videoRef = useRef(null);

  const handleVideoSrcSet = () => {
    setVideoSrc(window.innerWidth < 760 ? smallHeroVideo : heroVideo);
  };

  useEffect(() => {
    window.addEventListener("resize", handleVideoSrcSet);
    return () => window.removeEventListener("resize", handleVideoSrcSet);
  }, []);

  useGSAP(
    () => {
      const tl = gsap.timeline();

      // 1. Arka plan ışığının yavaş hareketi (Ambient Movement)
      gsap.to("#ambient-glow", {
        x: 100,
        y: 50,
        duration: 10,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      // 2. İmleç yanıp sönme efekti
      gsap.to("#cursor", {
        opacity: 0,
        repeat: -1,
        duration: 0.7,
        ease: "steps(1)",
      });

      // 3. ANA ANİMASYON AKIŞI
      tl.to("#hero-title", {
        opacity: 1,
        duration: 1,
      })
        .to(
          "#hero-subtitle",
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
          },
          "-=0.5",
        )
        .to("#hero-title", {
          duration: 1.5,
          text: "iPhone 15 Pro",
          ease: "none",
          delay: 1,
        })
        .to(
          "#hero-subtitle",
          {
            opacity: 0,
            y: -10,
            duration: 0.5,
          },
          "-=1.5",
        )
        .to(["#title-wrapper", "#cursor"], {
          y: -140,
          scale: 0.75,
          duration: 1.2,
          ease: "power4.inOut",
        })
        .to(
          "#hero-video",
          {
            opacity: 1,
            scale: 1,
            duration: 2,
            ease: "expo.out",
          },
          "-=0.8",
        )
        .to(
          "#cta",
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
          },
          "-=1",
        );
    },
    { scope: containerRef },
  );

  return (
    <section
      ref={containerRef}
      className="relative w-full h-screen bg-black overflow-hidden flex flex-col items-center justify-center"
    >
      {/* Üst Gradyan Katmanı */}
      <div className="absolute top-0 w-full h-64 bg-gradient-to-b from-black to-transparent z-10 pointer-events-none" />

      {/* Yazı & İmleç Grubu */}
      <div
        id="title-wrapper"
        className="z-20 text-center absolute flex flex-col items-center"
      >
        <div className="flex items-center justify-center relative">
          <h1
            id="hero-title"
            className="opacity-0 text-zinc-100 font-semibold text-5xl md:text-8xl tracking-tighter"
          >
            566dev Studio
          </h1>
          {/* Typing Cursor */}
          <span
            id="cursor"
            className="h-10 md:h-16 w-1 bg-blue-600 ml-2 rounded-full"
          />
        </div>

        <p
          id="hero-subtitle"
          className="text-zinc-500 text-lg md:text-2xl mt-4 font-light tracking-[0.2em] opacity-0 translate-y-4"
        >
          ENGINEERING EXCELLENCE
        </p>
      </div>

      {/* Video Bölümü (Floating effect ile) */}
      <div className="relative w-full md:w-10/12 lg:w-8/12 overflow-hidden px-4 mt-24">
        <video
          id="hero-video"
          ref={videoRef}
          className="pointer-events-none w-full h-auto opacity-0 scale-95  "
          autoPlay
          muted
          playsInline
          key={videoSrc}
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
      </div>

      {/* CTA (Call to Action) */}
      <div
        id="cta"
        className="absolute bottom-10 flex flex-col items-center opacity-0 translate-y-10 z-30 w-full px-6"
      >
        <div className="flex flex-col sm:flex-row items-center gap-5 mb-8">
          <a
            href="#highlights"
            className="group relative px-10 py-4 bg-white text-black rounded-full font-bold transition-all duration-300 hover:bg-zinc-200 overflow-hidden"
          >
            <span className="relative z-10">Explore the Tech</span>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
          </a>
          <a
            href="#contact"
            className="px-10 py-4 bg-transparent text-white border border-white/20 rounded-full font-medium hover:bg-white/5 transition-all duration-300 backdrop-blur-sm"
          >
            Get a Quote
          </a>
        </div>

        <div className="flex items-center gap-3">
          <span className="w-12 h-px bg-zinc-800" />
          <p className="text-zinc-500 font-medium text-xs uppercase tracking-[0.3em]">
            Titanium Grade Design
          </p>
          <span className="w-12 h-px bg-zinc-800" />
        </div>
      </div>

      {/* Dinamik Arka Plan Glow */}
      <div
        id="ambient-glow"
        className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-blue-600/10 blur-[140px] rounded-full pointer-events-none"
      />
      <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-purple-600/5 blur-[120px] rounded-full pointer-events-none" />
    </section>
  );
};

export default Hero;
